export default {
	'展位基本信息':'展位基本信息',
	'展位面积(m²)':'展位面积(m²)',
	'请输入展位面积':'请输入展位面积',
	'展台尺寸（长x宽）':'展台尺寸（长x宽）',
	'请输入展台尺寸':'请输入展台尺寸',
	'最高的至地面垂直高度(m)':'最高的至地面垂直高度(m)',
	'请输入最高的至地面垂直高度':'请输入最高的至地面垂直高度',
	'顶部结构覆盖面积(m²)':'顶部结构覆盖面积(m²)',
	'请输入顶部结构覆盖面积':'请输入顶部结构覆盖面积',
	'横跨结构最大尺寸(m)':'横跨结构最大尺寸(m)',
	'请输入横跨结构最大尺寸':'请输入横跨结构最大尺寸',
	'展位用电总功率(kw)':'展位用电总功率(kw)',
	'请输入展位用电总功率':'请输入展位用电总功率',
	'承重墙体最小厚度(cm)':'承重墙体最小厚度(cm)',
	'请输入承重墙体最小厚度':'请输入承重墙体最小厚度',
	'用电线路规格(m²)':'用电线路规格(mm²)',
	'请输入用电线路规格':'请输入用电线路规格',
	'上一步':'上一步',
	'下一步':'保存并下一步',
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingsBoothInfo.js